import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    filterBtn: [
      { text: 'UROMAT', color: '#1976d2' },
      { text: 'ADAPTIX', color: '#f15a29' },
      { text: 'TL3000', color: '#fb8c00' },
      { text: 'ZUBEHÖR', color: '#2196f3' },
      { text: 'EST', color: '#4caf50' },
      { text: 'SONSTIGE', color: '#8b8b8b' },
      { text: 'ALLE', color: '#f5f5f5' },
    ],
    prodStatus: [
      { text: 'geplant', color: '#ffffff' },
      { text: 'SN', color: '#ffff80' },
      { text: 'Freigabe', color: '#ffac84' },
      { text: 'Mechanik', color: '#95ffff' },
      { text: 'Elektrik', color: '#a4a4ff' },
      { text: 'Staging', color: '#97ff97' },
      { text: 'QM', color: '#00c400' },
      { text: 'Versand', color: '#ffa8ff' },
      { text: 'Geliefert', color: '#d1d1d1' },
    ],
    articles: [],
    // for drag & drop
    startCell: {},
  },
  getters: {
    prodStatus: (state) => state.prodStatus,
    filterBtn: (state) => state.filterBtn,
    articles: (state) => state.articles,
    // drag & drop
    startCell: (state) => state.startCell,
  },
  mutations: {
    setArticles(state, value) {
      state.articles = value
    },
    // drag & drop
    setStartCell(state, value) {
      state.startCell = value
    },
  },
  actions: {},
  modules: {},
}
